export default "__VITE_ASSET__CajL2dFb__"